export enum OrderExceptionsAnalyticsMessages {
  submitEvent = 'order submitted',
  capability = 'exceptions',
  openMethod = 'exceptions',
  pageLoadedEvent = 'page loaded',
  removeFromOrder = 'remove from order',
  pageName = 'us foods:r4:exceptions',
}
